import { render, staticRenderFns } from "./PlugComponent.vue?vue&type=template&id=4226c8e8&"
import script from "./PlugComponent.vue?vue&type=script&lang=js&"
export * from "./PlugComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlugComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports